import React from "react";

// Kolom "Approval" di Riwayat Cuti: siapa saja aktornya dan approval sudah sampai mana.
// Data dari backend (GetCutiApprovalActors): ✅ sudah approve · ⏳ sedang menunggu aktor
// ini (Posisi) · ⌛ belum giliran · ❌ menolak. Dipakai CutiPage & EntryCutiPage.
export default function CutiApprovalActors({ list }) {
  if (!Array.isArray(list) || list.length === 0) {
    return <span className="text-gray-400">-</span>;
  }
  return (
    <ol className="space-y-0.5 min-w-[210px]">
      {list.map((a, i) => (
        <li
          key={i}
          title={a.Keterangan || undefined}
          className={
            a.Posisi
              ? "flex items-start gap-1 rounded bg-yellow-50 border border-yellow-200 px-1.5 py-0.5 font-semibold text-yellow-800"
              : "flex items-start gap-1 px-1.5 text-gray-700"
          }
        >
          <span>{a.Status}</span>
          <span>
            {a.Urutan ? `${a.Urutan}. ` : ""}
            {a.Nama}
            {a.Posisi && <span className="ml-1 text-[10px] font-bold uppercase">← posisi sekarang</span>}
            {a.Keterangan && !a.Posisi && (
              <span className="block text-[10px] text-gray-400 font-normal">{a.Keterangan}</span>
            )}
          </span>
        </li>
      ))}
    </ol>
  );
}
